import { IRole } from 'types/database/users/user'
import { IRouterConditionProps } from './interfaces'

export const logged = (state: IRouterConditionProps) =>
  !!state.user?.data && !!state.user?.auth

export const notLogged = (state: IRouterConditionProps) => !logged(state)

export const plusUser = (state: IRouterConditionProps) =>
  !!state.plus_user?.isPlusUser

export const isParent = (state: IRouterConditionProps) =>
  state?.user?.data?.role === IRole.parent

export const notPlusUser = (state: IRouterConditionProps) => !plusUser(state)

export const loggedAndPlusUser = (state: IRouterConditionProps) =>
  logged(state) && plusUser(state)

export const loggedAndParent = (state: IRouterConditionProps) =>
  logged(state) && isParent(state)

export const notLoggedOrNotPlusUser = (state: IRouterConditionProps) =>
  notLogged(state) || notPlusUser(state)

export const notPlusUserAndLogged = (state: IRouterConditionProps) =>
  notPlusUser(state) && logged(state)

export default {
  logged,
  notLogged,
  plusUser,
  notPlusUser,
  loggedAndPlusUser,
  notLoggedOrNotPlusUser,
  loggedAndParent
}



// WEBPACK FOOTER //
// ./src/routes/controllers.ts